import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import Impersonation from './Impersonation';
import User from './User';
import Cart from './Cart';
import { LanguageSelector } from 'ui/components';

import './Header.scss';
export default class Header extends Component {
	render() {
		return (
			<header className="snapon--header Header">
				<nav className="navbar">
					<div className="container-fluid">
						<div className="navbar-header">
							<Link to="/" className="navbar-brand">
								SOLO
							</Link>
						</div>
						<ul className="nav navbar-nav navbar-right">
							<li className="navbar-nav-content">
								<LanguageSelector />
							</li>
							<li className="navbar-nav-content">
								<User />
							</li>
							<li className="navbar-content">
								<Impersonation />
							</li>
							<li className="navbar-content navbar-nav-borderless">
								<Cart />
							</li>
						</ul>
					</div>
				</nav>
			</header>
		);
	}
}



// WEBPACK FOOTER //
// ./src/ui/components/Header/index.js